export { Label as InputLabel, LabelProps as InputLabelProps } from '../../Data Display/Label'
